import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import * as constants from '../const/constants';

@Pipe({
  name: 'editFormatDate'
})
export class EditFormatDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      return [...new Set(value.map(d =>
        moment(d).format(constants.CONFIGURATION.DEFAULT_DATE_FORMAT))
        .sort((d1, d2) => new Date(d1.date).getTime() - new Date(d2.date).getTime())
        )];
    }
    return [];
  }

}
